<template>
	<div class="fill-height">
		<modal-assinatura-eletronica
			v-if="exibirModalAssinaturaEletronica"
			titulo="Assinar"
			nome-botao-confirmar="Assinar"
			:exibir="exibirModalAssinaturaEletronica"
			@fechar-modal="fecharModalAssinaturaTermo"
			@assinar-eletronicamente="assinarEletronicamente"
		></modal-assinatura-eletronica>
		<az-pdf-document-viewer
			v-if="passoEdicaoFinalizado"
			id="azPdfDocumentViewer"
			:src="documentoSrc"
			progress-bar
			default-scale-type="auto"
		></az-pdf-document-viewer>
		<botao-assinar-documento
			v-if="!passoAssinaturaFinalizado"
			id="botaoAssinar"
			@assinar="abrirModalAssinaturaTermo"
		></botao-assinar-documento>
	</div>
</template>

<script>
import { actionTypes } from '@/core/constants'
import ModalAssinaturaEletronica from '@/views/components/assinatura/eletronica/ModalAssinaturaEletronica.vue'
import assinatura from '@/views/mixins/assinatura'

export default {
	name: 'termo-desentranhamento-assinar',
	components: { ModalAssinaturaEletronica },
	mixins: [assinatura],
	props: {
		passoEdicaoFinalizado: {
			type: Boolean,
		},
		passoAssinaturaFinalizado: {
			type: Boolean,
		},
	},
	data() {
		return {
			idProcessoAquisicao: null,
			exibirModalAssinaturaEletronica: false,
			tituloModal: 'Assinar',
			idTermo: null,
			documentoSrc: null,
			documento: [],
		}
	},
	async mounted() {
		this.setIdTermo()
		this.setIdProcessoAquisicao()
		this.setDocumentoSrc()
		await this.setDocumento()
	},
	methods: {
		abrirModalAssinaturaTermo() {
			this.exibirModalAssinaturaEletronica = true
		},
		fecharModalAssinaturaTermo() {
			this.exibirModalAssinaturaEletronica = false
		},
		async setDocumento() {
			const data = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.BUSCAR_POR_ID,
				this.idTermo,
			)
			this.documento = [
				{
					titulo: data.titulo,
					idAssociacao: this.idTermo,
				},
			]
		},
		setDocumentoSrc() {
			this.documentoSrc = `/ata-registro-preco/api/atas/documentos/${this.idTermo}/processo-digital/download-impressao`
		},
		setIdTermo() {
			this.idTermo = this.$route.params.idTermo
		},
		setIdProcessoAquisicao() {
			this.idProcessoAquisicao = this.$route.params.id
		},
		async assinarEletronicamente() {
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE,
				this.idTermo,
			)
			await this.tratarEventoAssinarTermo()
		},
		async tratarEventoAssinarTermo() {
			this.$emit('assinar-termo')
			this.fecharModalAssinaturaTermo()
		},
	},
}
</script>
